import React from "react";
import { useSiteContent } from "../contexts/SiteContentContext";

/** Oznamovací pruh pod hero — tmavý pruh s akcentním textem. */
export default function AnnouncementBanner() {
  const { text } = useSiteContent();
  const banner = text.announcement_banner || {};
  if (!banner.active || !banner.text) return null;

  return (
    <div
      style={{ background: "linear-gradient(100deg, rgba(201,166,107,0.22) 0%, rgba(201,166,107,0.05) 40%, transparent 65%), var(--uhel-700)" }}
      data-testid="announcement-banner"
    >
      <div className="max-w-[1180px] mx-auto px-[22px] md:px-8 py-[19px]">
        <p className="text-[20.3px] md:text-[21.6px] text-krem-100" data-testid="announcement-banner-text">
          {banner.text}
        </p>
      </div>
    </div>
  );
}
